import { styled } from '@linaria/react';

import { random } from '@/utils';

import Sparkles from '@/components/Sparkles';

const generatePosition = () => {
  let style = {};
  style.left = random(0, 100) + '%';
  style.top = random(0, 100) + '%';
  style.zIndex = 3;

  return style;
};

const SparkleGlitter = ({ children }) => {
  return (
    <Sparkles
      style={{ padding: 0 }}
      colors={['#FFF']}
      generatePosition={generatePosition}
      isToggleable={false}
    >
      <Image
        src="/images/animated-sparkles-in-react/glitter.jpg"
        alt="An open bottle of gold glitter"
      />
    </Sparkles>
  );
};

const Image = styled.img`
  display: block;
  height: 125px;
`;

export default SparkleGlitter;
